import React from "react";

/* Radio — single + RadioGroup. Green dot when selected. */
export function Radio({ checked = false, onChange, label, value, disabled = false, style, ...rest }) {
  const select = () => !disabled && onChange && onChange(value);
  return (
    <label
      role="radio"
      aria-checked={checked}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      onClick={select}
      onKeyDown={(e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          select();
        }
      }}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        fontFamily: "var(--font-sans)",
        fontWeight: 500,
        fontSize: 14,
        color: "var(--text-body)",
        ...style,
        // Layout is structural, not cosmetic — never let caller `style` collapse the dot/label gap.
        display: "inline-flex",
        alignItems: "center",
        gap: 10,
      }}
      {...rest}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 20,
          height: 20,
          flex: "none",
          borderRadius: "50%",
          background: "var(--white)",
          boxShadow: checked ? "inset 0 0 0 1.5px var(--green-bright)" : "inset 0 0 0 1.5px var(--border-strong)",
          transition: "box-shadow var(--dur) var(--ease)",
        }}
      >
        {checked ? <span style={{ width: 10, height: 10, borderRadius: "50%", background: "var(--green-bright)" }} /> : null}
      </span>
      {label ? <span>{label}</span> : null}
    </label>
  );
}

export function RadioGroup({ value, onChange, options = [], gap = 12, direction = "column", style, ...rest }) {
  const norm = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  return (
    <div role="radiogroup" style={{ display: "flex", flexDirection: direction, gap, ...style }} {...rest}>
      {norm.map((o) => (
        <Radio key={o.value} value={o.value} label={o.label} checked={value === o.value} onChange={onChange} disabled={o.disabled} />
      ))}
    </div>
  );
}

export default Radio;
